//region block: pre-declaration
//endregion
function _B0___init__impl__6otxhp(b0) {
  return b0;
}
function _B0___get_b0__impl__g161pk($this) {
  return $this;
}
//region block: exports
export {
  _B0___init__impl__6otxhp as _B0___init__impl__6otxhp396vljhhfyxue,
  _B0___get_b0__impl__g161pk as _B0___get_b0__impl__g161pk37yy08sxjtbie,
};
//endregion

//# sourceMappingURL=-EndianUtils.mjs.map
